var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ToastActionButtonElement } from './elements';
export var ToastActionButton = React.forwardRef(function (_a, fRef) {
    var id = _a.id, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.ariaLabel, ariaLabel = _c === void 0 ? '' : _c, children = _a.children, rest = __rest(_a, ["id", "className", "ariaLabel", "children"]);
    return (React.createElement(ToastActionButtonElement, __assign({ ref: fRef, id: id, "aria-label": ariaLabel, className: className }, rest), children));
});
